export const DEFAULT_FILTERS = {
  id: {
    title: 'Form ID',
    values: null,
    allowed_operators: ['contains', 'does not contain'],
    icon: 'text-num-mono'
  },
  created_at: {
    type: 'date-range',
    title: 'Created at',
    icon: 'calendar-2-mono'
  },
  updated_at: {
    type: 'date-range',
    title: 'Updated on',
    icon: 'calendar-2-mono'
  },
  name: {
    title: 'Name',
    placeholder: 'Search by name',
    allowed_operators: ['contains', 'does not contain'],
    icon: 'first-line-mono'
  },
  version: {
    title: 'Version',
    placeholder: 'Search by version',
    allowed_operators: ['contains', 'does not contain'],
    icon: 'file-text-mono'
  }
};
